<template>
  <v-dialog v-model="dShowAlert" persistent max-width="600" @keydown.esc="fClose">
    <v-card :class="dTypeAlert + 'Alert'">
      <v-card-title class="pa-0">
        <v-btn icon @click="fClose" class="ml-auto" :aria-label="$t('cerrar') + ' ' + $t('label.alert')">
          <v-icon flat color="datClose">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-4 pt-0">
        <v-layout row wrap justify-center>
          <v-flex v-if="dIconAlert" shrink class="">
            <v-icon large class="icon"> {{ dIconAlert }}
            </v-icon>
          </v-flex>
          <v-flex xs12 class="text-xs-center my-3">
            <span class="ffP fs18 fcT240">{{dTextAlert}}</span>
          </v-flex>
          <v-flex v-if="dAuxTextAlert" xs12 class="text-xs-center my-1">
            <span class="ffP fs12 fcT2">{{dAuxTextAlert}}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions v-if="dTypeAlert !== 'info' && dTypeAlert !== 'infoWButton' && dTypeAlert !== 'errorWButton' && dTypeAlert !== 'dontAsk'" class="justify-center pb-3">
        <v-btn v-if="dBtnAuxText" class="alertBtnText" flat @click="fActionAux">{{dBtnAuxText}}</v-btn>
        <v-btn v-else class="alertBtnText mr-2" flat @click="fClose">{{ $t('alertsCancel') }}</v-btn>
        <v-btn class="alertBtn" flat @click="fAction">{{dBtnText}}</v-btn>
      </v-card-actions>

      <v-card-actions v-if="dTypeAlert === 'infoWButton' || dTypeAlert === 'errorWButton'" class="justify-center pb-3">
        <v-btn class="alertBtnOut mr-2" focus flat @click="fClose" ref="close" @keypress.enter="fClose">{{dBtnNegText}}</v-btn>
      </v-card-actions>

      <v-card-actions v-if="dTypeAlert === 'dontAsk'" class="justify-center pb-3">
        <v-layout row wrap class="ma-0 justify-center">

          <v-flex shrink class="pa-0">
            <v-checkbox v-model="dDontAsk" :label="$t('alerts.dontAsk')" hide-details class="pa-0 ma-0" color="datPrimary"></v-checkbox>
          </v-flex>
          <v-flex xs12 class="pt-3 pb-2 text-xs-center">

            <v-btn class="alertBtnText mr-2" flat @click="fCloseDontAsk">{{ $t('alertsCancel') }}</v-btn>
            <v-btn class="alertBtn" flat @click="fAction">{{dBtnText}}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
 
<script>
export default {
  data () {
    return {
      dShowAlert: false,
      dTypeAlert: '',
      dTextAlert: '',
      dIconAlert: '',
      dBtnText: '',
      dAuxTextAlert: '',
      dBtnNegText: '',
      dBtnAuxText: '',
      dDontAsk: false
    }
  },

  methods: {
    fClose () {
      if (this.fNegAction) {
        this.fNegAction()
      }
      if (this.dTypeAlert === 'infoWButton') {
        this.fActionAlert()
      }
      this.dShowAlert = false
    },
    fAction () {
      if (this.dTypeAlert === 'dontAsk' && this.dDontAsk) {
        this.fActionAuxAlert()
      } else {
        this.fActionAlert()
      }
      this.dShowAlert = false
    },
    fActionAux () {
      this.fActionAuxAlert()
      this.dShowAlert = false
    },
    fCloseDontAsk () {
      if (this.dDontAsk) {
        this.fNegAction()
      }
      this.dShowAlert = false
    }
  },
  computed: {
  },
  mounted () {
    this.$bus.$on('showAlert', alert => {
      this.dTypeAlert = alert.type ? alert.type : ''
      this.dTextAlert = alert.text ? alert.text : ''
      this.dAuxTextAlert = alert.auxText ? alert.auxText : ''
      this.dIconAlert = alert.icon ? alert.icon : ''

      this.dBtnText = alert.btnText ? alert.btnText : this.$t('alertsAceptar')
      this.fActionAlert = alert.action ? alert.action : () => {}
      this.dBtnAuxText = alert.btnAuxText ? alert.btnAuxText : ''
      this.fActionAuxAlert = alert.actionAux ? alert.actionAux : () => {}
      this.dBtnNegText = alert.btnNegText ? alert.btnNegText : this.$t('btn.close')
      this.fNegAction = alert.negAction ? alert.negAction : () => {}
      this.dShowAlert = true
    })
  },
  beforeDestroy () {
    this.$bus.$off('showAlert')
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/datAlert.vue